// A feature check rather than a probe context: browsers cap live WebGL contexts
// per process, and creating a throwaway one can evict a context that is in use.
// A browser that has the API but still can't create a context is caught by the
// scene's error boundary instead.
export function canUseWebGL() {
  return typeof window !== 'undefined' && 'WebGLRenderingContext' in window
}
